export default {
  /**
   * Sets the setCorePageLoadComplete value on the state.
   *
   * @param {Object} state
   * @param {boolean} value
   */
  setCorePageLoadComplete(state, value) {
    state.corePageLoadComplete = value
  },

  /**
   * Sets the mobile menu open value
   *
   * @param {Object} state
   * @param {boolean} value
   */
  setMobileMenuOpen(state, value) {
    state.mobileMenuOpen = value
  },

  /**
   * Sets the floatingFooterVisible flag value.
   *
   * @param {Object} state
   * @param {boolean} value
   */
  setFloatingFooterVisible(state, value) {
    state.floatingFooterVisible = value
  },

  /**
   * Dummy mutation. This is intercepted by the Vue instance and handled to avoid circular references with the router.
   */
  navigate() {},
}
